import { itemsPerPage, tabs } from "../../../../../common/constants/search-constants"
import { Tab } from "../../../../../common/types/global"
import InfiniteScroll from "./InfiniteScroll/InfiniteScroll"
import LoadMoreButton from "./LoadMoreButton/LoadMoreButton"

type Props = {
  selectedTab: Tab
  remainingItems: number
  handleLoadMore: () => void
  isInfiniteScroll: boolean
}

const PageLoader = ({ selectedTab, remainingItems, handleLoadMore, isInfiniteScroll }: Props) => {
  return isInfiniteScroll ? (
    <InfiniteScroll handleLoadMore={handleLoadMore} />
  ) : (
    <LoadMoreButton
      label={selectedTab === tabs.PRO ? "search-load-more-products" : "search-load-more-spare-parts"}
      loadNumberOfItems={remainingItems > itemsPerPage[selectedTab] ? itemsPerPage[selectedTab] : remainingItems}
      handleLoadMore={handleLoadMore}
    />
  )
}

export default PageLoader
